import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-error-code',
  imports: [RouterLink, MatButtonModule],
  templateUrl: './error-code.component.html',
  styleUrl: './error-code.component.scss'
})
export class ErrorCodeComponent {
  @Input() code = '';
  @Input() title = '';
  @Input() message = '';
}
